var _path, _path2, _path3, _g, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewPinTo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 72,
    viewBox: "0 0 68 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6452 71.3549C38.2083 71.3549 41.0968 68.4664 41.0968 64.9033C41.0968 61.3401 38.2083 58.4517 34.6452 58.4517C31.0821 58.4517 28.1936 61.3401 28.1936 64.9033C28.1936 68.4664 31.0821 71.3549 34.6452 71.3549Z",
    fill: "#A1A1A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6451 68.7742C36.783 68.7742 38.5161 67.0411 38.5161 64.9032C38.5161 62.7653 36.783 61.0322 34.6451 61.0322C32.5073 61.0322 30.7742 62.7653 30.7742 64.9032C30.7742 67.0411 32.5073 68.7742 34.6451 68.7742Z",
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6451 40.3871C33.9324 40.3871 33.3547 40.9648 33.3547 41.6774V64.9032C33.3547 65.6158 33.9324 66.1935 34.6451 66.1935C35.3577 66.1935 35.9354 65.6158 35.9354 64.9032V41.6774C35.9354 40.9648 35.3577 40.3871 34.6451 40.3871Z",
    fill: "#A1A1A1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_349_1231)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0001 50.7097C44.6895 50.7097 53.3549 42.0442 53.3549 31.3548C53.3549 20.6655 44.6895 12 34.0001 12C23.3107 12 14.6453 20.6655 14.6453 31.3548C14.6453 42.0442 23.3107 50.7097 34.0001 50.7097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6637 31.3548C52.6637 41.6625 44.3077 50.0184 34.0001 50.0184C23.6925 50.0184 15.3365 41.6625 15.3365 31.3548C15.3365 21.0472 23.6925 12.6912 34.0001 12.6912C44.3077 12.6912 52.6637 21.0472 52.6637 31.3548Z",
    stroke: "#DBDBDB",
    strokeWidth: 1.38249
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 46.8387C42.5515 46.8387 49.4839 39.9063 49.4839 31.3548C49.4839 22.8033 42.5515 15.871 34 15.871C25.4485 15.871 18.5161 22.8033 18.5161 31.3548C18.5161 39.9063 25.4485 46.8387 34 46.8387Z",
    fill: "#FFDD00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_349_1231",
    x: 0.451715,
    y: 0.387097,
    width: 67.0968,
    height: 67.0968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.58065
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.09677
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_349_1231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_349_1231",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPinTo);
export default __webpack_public_path__ + "static/media/new-pin-to.d666fb7d56a0bf4d09a943028d83b604.svg";
export { ForwardRef as ReactComponent };